import React from 'react';
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  Location
} from 'react-router-dom';

export interface RouterProps {
  location: Location,
  navigate: NavigateFunction,
}

interface WithRouterProps {
  router: RouterProps
}


export default function withRouter<T extends WithRouterProps>(WrappedComponent: React.ComponentType<T>) {
  function ComponentWithRouterProp(props: Omit<T, keyof WithRouterProps>) {
    const location = useLocation();
    const navigate = useNavigate();
    return (
      <WrappedComponent
        {...props as T}
        router={{ location, navigate }}
      />
    );
  }

  return ComponentWithRouterProp;
}